import {
  Card,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from '@mui/material';
import React from 'react';
import ProductListContent from './ListContent';
import ProductListHead from './ListHead';
import ProductListToolbar from './ListToolbar';
import Loading from '../Loading/loading';

export default function ProductListTable({
  filteredData,
  fetchData,
  addModal,
  columnFields,
  tableName,
  selectedCategory,
  handleCategoryChange,
  pageSize,
  page,
  handleFilterByName,
  filterName,
  loading,
  setMessage,
  setSnackbarOpen,
}) {
  const cumulativeProductCount = page * pageSize;

  const noProductsAdded = !filteredData.length && !filterName;
  const isNotFound = !filteredData.length && !!filterName;

  return (
    <>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography variant="h4" gutterBottom>
          {tableName}
        </Typography>
        {addModal}
      </Stack>

      <Card>
        <ProductListToolbar
          filterName={filterName}
          onFilterName={handleFilterByName}
          selectedCategory={selectedCategory}
          onCategoryChange={handleCategoryChange}
        />
        <TableContainer sx={{ minWidth: 600 }}>
          {loading ? (
            <Loading />
          ) : (
            <Table>
              <ProductListHead headLabel={columnFields} />
              <TableBody>
                {filteredData.map((row, index) => (
                  <ProductListContent
                    key={row.id}
                    row={row}
                    columns={columnFields}
                    index={cumulativeProductCount + index}
                    fetchData={fetchData}
                    tableName={tableName}
                    setMessage={setMessage}
                    setSnackbarOpen={setSnackbarOpen}
                  />
                ))}
              </TableBody>
              {noProductsAdded && (
                <TableBody>
                  <TableRow>
                    <TableCell
                      align="center"
                      colSpan={7}
                      sx={{ py: 3, textAlign: 'center' }}>
                      <Typography variant="body2">
                        No products have been added yet
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}

              {isNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell
                      align="center"
                      colSpan={7}
                      sx={{ py: 3, textAlign: 'center' }}>
                      <Typography variant="body2">
                        No matching products found
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          )}
        </TableContainer>
      </Card>
    </>
  );
}